module.exports = __webpack_public_path__ + "img/arenaroom.a5a1897b.png";